/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';

/**
 * 
 * @export
 * @interface Employer
 */
export interface Employer {
    /**
     * 
     * @type {string}
     * @memberof Employer
     */
    ico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Employer
     */
    name?: string | null;
    /**
     * 
     * @type {Address}
     * @memberof Employer
     */
    address?: Address;
}

/**
 * Check if a given object implements the Employer interface.
 */
export function instanceOfEmployer(value: object): value is Employer {
    return true;
}

export function EmployerFromJSON(json: any): Employer {
    return EmployerFromJSONTyped(json, false);
}

export function EmployerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Employer {
    if (json == null) {
        return json;
    }
    return {
        
        'ico': json['ico'] == null ? undefined : json['ico'],
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
    };
}

export function EmployerToJSON(json: any): Employer {
    return EmployerToJSONTyped(json, false);
}

export function EmployerToJSONTyped(value?: Employer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ico': value['ico'],
        'name': value['name'],
        'address': AddressToJSON(value['address']),
    };
}

